/**
 * Pavé numérique tactile. Les touches font 56 px de haut : au comptoir on tape
 * debout, parfois d'une main, souvent sans regarder.
 */

const TOUCHES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '0', '←'] as const

export function Pave({
  onTouche,
  onEffacer,
  decimales = true,
  etire = false,
}: {
  onTouche: (touche: string) => void
  onEffacer: () => void
  /** Masque la virgule quand la saisie ne porte que sur des numéros d'article. */
  decimales?: boolean
  /** Les touches remplissent toute la hauteur disponible — colonne de caisse. */
  etire?: boolean
}) {
  return (
    <>
      <div className={etire ? 'pave pave-etire' : 'pave'}>
        {TOUCHES.map((touche) => (
          <button
            key={touche}
            type="button"
            className={touche === '←' ? 'pave-touche secondaire' : 'pave-touche'}
            disabled={touche === ',' && !decimales}
            onClick={() => onTouche(touche)}
          >
            {touche === ',' && !decimales ? '' : touche}
          </button>
        ))}
      </div>
      <button type="button" className="btn btn-secondaire btn-bloc btn-centre" onClick={onEffacer}>
        Effacer
      </button>
    </>
  )
}

/** Applique une frappe du pavé à une saisie en cours. */
export function appliquerTouche(saisie: string, touche: string): string {
  if (touche === '←') return saisie.slice(0, -1)
  if (touche === ',') return saisie.includes(',') ? saisie : `${saisie || '0'},`
  // Deux décimales suffisent, et la saisie ne dépasse jamais 9 signes.
  const virgule = saisie.indexOf(',')
  if (virgule >= 0 && saisie.length - virgule > 2) return saisie
  return (saisie + touche).slice(0, 9)
}
